import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'

import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

export const CodeBlockComponent = ({
  node: {
    attrs: { language },
  },
  updateAttributes,
  extension,
}) => (
  <NodeViewWrapper className="code-block relative">
    <Dropdown
      className="left-auto right-2.5 top-2.5 absolute"
      placement="bottom-end"
    >
      <Dropdown.Button className="code-language-selector opacity-0 transition-opacity">
        {language || extension.options.defaultLanguage}
      </Dropdown.Button>
      <Dropdown.Items className="w-40 max-h-full h-80 overflow-y-auto divide-y divide-surface-200/50">
        {extension.options.lowlight.listLanguages().map(language => (
          <Dropdown.Item
            key={language}
            onClick={() => updateAttributes({ language })}
          >
            {language}
          </Dropdown.Item>
        ))}
      </Dropdown.Items>
    </Dropdown>
    <pre>
      <NodeViewContent as="code" />
    </pre>
  </NodeViewWrapper>
)
